import { c as _c } from "react/compiler-runtime";
import { Chip } from '@/comps/chip';
import { TooltipButton } from '@/comps/tooltip-button';
import { cn } from '@/utils/shad';
import { formatNumber } from '@/utils/format.util';
import { isNil } from 'lodash';
import { PieChartIcon, TrendingDownIcon, TrendingUpIcon } from 'lucide-react';
import { useMemo } from 'react';
export const BaseChip = t0 => {
  const $ = _c(5);
  const {
    children,
    className
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = cn("flex items-center gap-1 bg-accent/50 px-2 py-1 text-[10px] leading-3! text-accent-foreground uppercase", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== children || $[3] !== t1) {
    t2 = <Chip className={t1}>{children}</Chip>;
    $[2] = children;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
};
export const TrendingSubChip = t0 => {
  const $ = _c(28);
  const {
    delta,
    invert: t1,
    className
  } = t0;
  const invert = t1 === undefined ? false : t1;
  const isPositive = (delta ?? 0) >= 0;
  let t2;
  bb0: {
    if (isNil(delta)) {
      t2 = "N/A";
      break bb0;
    }
    const normalized = delta * 100;
    let t3;
    if ($[0] !== normalized) {
      t3 = normalized >= 0 ? `+${normalized.toFixed(0)}%` : `${normalized.toFixed(0)}%`;
      $[0] = normalized;
      $[1] = t3;
    } else {
      t3 = $[1];
    }
    t2 = t3;
  }
  const deltaString = t2;
  const TrendIcon = isPositive ? TrendingUpIcon : TrendingDownIcon;
  let T0;
  let T1;
  let t3;
  let t4;
  let t5;
  let t6;
  if ($[2] !== TrendIcon || $[3] !== className || $[4] !== invert || $[5] !== isPositive) {
    const colors = invert ? ["text-[#AC1E1E]", "text-[#47A919]"] : ["text-[#47A919]", "text-[#AC1E1E]"];
    const colorClass = isPositive ? colors[0] : colors[1];
    T1 = TooltipButton;
    t5 = 400;
    t6 = "Rate of change over the previous timespan. Adjust the timespan using the button in the upper right corner of the platform.";
    if ($[12] !== className) {
      t4 = cn("flex items-center justify-start gap-px rounded-[6px] bg-background px-1 py-0.5 text-[12px] leading-0 text-muted-foreground hover:cursor-pointer", className);
      $[12] = className;
      $[13] = t4;
    } else {
      t4 = $[13];
    }
    T0 = TrendIcon;
    t3 = cn("h-3 w-3", colorClass);
    $[2] = TrendIcon;
    $[3] = className;
    $[4] = invert;
    $[5] = isPositive;
    $[6] = T0;
    $[7] = T1;
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
    $[11] = t6;
  } else {
    T0 = $[6];
    T1 = $[7];
    t3 = $[8];
    t4 = $[9];
    t5 = $[10];
    t6 = $[11];
  }
  let t7;
  if ($[14] !== T0 || $[15] !== t3) {
    t7 = <T0 className={t3} />;
    $[14] = T0;
    $[15] = t3;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== deltaString) {
    t8 = <span className="">{deltaString}</span>;
    $[17] = deltaString;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] !== t4 || $[20] !== t7 || $[21] !== t8) {
    t9 = <div className={t4}>{t7}{t8}</div>;
    $[19] = t4;
    $[20] = t7;
    $[21] = t8;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  let t10;
  if ($[23] !== T1 || $[24] !== t5 || $[25] !== t6 || $[26] !== t9) {
    t10 = <T1 delay={t5} content={t6}>{t9}</T1>;
    $[23] = T1;
    $[24] = t5;
    $[25] = t6;
    $[26] = t9;
    $[27] = t10;
  } else {
    t10 = $[27];
  }
  return t10;
};
export const TotalPercentageChip = t0 => {
  const $ = _c(5);
  const {
    partial,
    total
  } = t0;
  const percentage = partial / total * 100;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <PieChartIcon className="h-3 w-3" />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== percentage) {
    t2 = percentage.toFixed(0);
    $[1] = percentage;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t2) {
    t3 = <Chip variant="muted" size="small" className="flex w-fit items-center gap-1 rounded-[6px] px-1.25 py-px text-[12px] text-nowrap text-muted-foreground">{t1}<TooltipButton delay={400} content="Percentage respect to the interactions."><span className="hover:cursor-pointer">{t2}% Total</span></TooltipButton></Chip>;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
};
export const TotalsChip = t0 => {
  const $ = _c(10);
  const {
    total,
    className,
    toolTip
  } = t0;
  const t1 = toolTip ?? "Total amount in the selected timespan. Adjust the timespan using the button in the upper right corner of the platform.";
  const t2 = className ?? "";
  let t3;
  if ($[0] !== t2) {
    t3 = cn("rounded-[8px] border border-[#45474a4b] bg-[#3133374e] px-1 py-0.5 text-[11px] leading-none! text-[#9FA1A6]", t2);
    $[0] = t2;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] !== total) {
    t4 = formatNumber(total);
    $[2] = total;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== t3 || $[5] !== t4) {
    t5 = <span><Chip className={t3} variant="muted">{t4}</Chip></span>;
    $[4] = t3;
    $[5] = t4;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== t1 || $[8] !== t5) {
    t6 = <TooltipButton content={t1}>{t5}</TooltipButton>;
    $[7] = t1;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  return t6;
};